// assets/dollarlabs-pricing.js
(function () {
    if (window.__DOLLARLABS_PRICING_LOADED__) return;
    window.__DOLLARLABS_PRICING_LOADED__ = true;
    console.log('[DollarlabsPricing] loaded');

    const currencyFormat = window.DollarlabsCurrencyFormat || null;

    const formatWithDelimiters = (number, precision = 2, thousands = ",", decimal = ".") => {
        if (isNaN(number) || number == null) return "0";
        const numString = (number / 100.0).toFixed(precision);
        const parts = numString.split(".");
        const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
        const cents = parts[1] ? decimal + parts[1] : "";
        return dollars + cents;
    };

    const shopifyFormatCurrency = (cents, formatString, options = {}) => {
        if (!formatString) return (cents / 100).toFixed(2);

        const { showCurrencyCode = false, currencyCodePosition = 'right' } = options;
        const currencyCode = window.Shopify?.currency?.active || 'USD';

        const placeholderRegex = /{{\s*(\w+)\s*}}/;
        let formattedPrice = formatString.replace(placeholderRegex, (match, placeholder) => {
            switch (placeholder) {
                case "amount": return formatWithDelimiters(cents, 2);
                case "amount_no_decimals": return formatWithDelimiters(cents, 0);
                case "amount_with_comma_separator": return formatWithDelimiters(cents, 2, ".", ",");
                case "amount_no_decimals_with_comma_separator": return formatWithDelimiters(cents, 0, ".", ",");
                case "amount_with_apostrophe_separator": return formatWithDelimiters(cents, 2, "'", ".");
                case "amount_no_decimals_with_space_separator": return formatWithDelimiters(cents, 0, " ");
                case "amount_with_space_separator": return formatWithDelimiters(cents, 2, " ", ",");
                case "amount_with_period_and_space_separator": return formatWithDelimiters(cents, 2, " ", ".");
                default: return match;
            }
        });

        // Add currency code if requested
        if (showCurrencyCode) {
            if (currencyCodePosition === 'left') {
                formattedPrice = `${currencyCode} ${formattedPrice}`;
            } else {
                formattedPrice = `${formattedPrice} ${currencyCode}`;
            }
        }

        return formattedPrice;
    };

    function renderFallback(el, originalPrice, options = {}) {
        const { showCurrencyCode = false, currencyCodePosition = 'right' } = options;
        el.innerHTML = `<span class="dollarlabs_pricelist--regular_price" style="color: black; font-size: 14px; font-weight: 500;">
      ${shopifyFormatCurrency(originalPrice, currencyFormat, { showCurrencyCode, currencyCodePosition })}
    </span>`;
        el.dataset.dollarlabsFallback = 'true';
    }

    function renderLoginRequired(el) {
        el.innerHTML = `
    <span class="dollarlabs_pricelist--login_required" style="color: #555; font-size: 14px; font-weight: 500; display: flex; align-items: center; gap: 6px; cursor: pointer;">
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
        <path d="M8 1a4 4 0 0 0-4 4v3H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1h-1V5a4 4 0 0 0-4-4zM6 5a2 2 0 1 1 4 0v3H6V5z"/>
      </svg>
      <a href="/account/login" style="text-decoration: none; color: inherit;">Sign in to see price</a>
    </span>
  `;
        el.dataset.dollarlabsLoginRequired = 'true';
    }

    function renderPrice(el) {
        const variantId = el.dataset.variantId;
        const originalPrice = parseInt(el.dataset.originalPrice) || 0;
        const showOriginalPrice = el.dataset.showOriginalPrice === 'true';
        const showCompareAtPrice = el.dataset.showCompareAtPrice === 'true';
        const compareAtPrice = parseInt(el.dataset.compareAtPrice) || 0;

        // Get currency code options from data attributes
        const showCurrencyCode = el.dataset.showCurrencyCode === 'true';
        const currencyCodePosition = el.dataset.currencyCodePosition || 'right';

        if (!window.DollarlabsPriceCalculator || !window.DollarlabsPriceCalculator.isInitialized) {
            renderFallback(el, originalPrice, { showCurrencyCode, currencyCodePosition });
            return;
        }

        const priceInfo = window.DollarlabsPriceCalculator.getPrice(variantId, originalPrice) || {};
        let html = '';

        const currencyOptions = { showCurrencyCode, currencyCodePosition };

        if (priceInfo.hasDiscount) {
            if (showOriginalPrice) {
                html += `<span class="dollarlabs_pricelist--original_price" style="color: black; text-decoration: line-through; margin-right: 5px; font-size: 14px;">
          ${shopifyFormatCurrency(priceInfo.originalPrice, currencyFormat, currencyOptions)}
        </span>`;
            }
            html += `<span class="dollarlabs_pricelist--final_price" style="color: red; font-size: 20px;">
        ${shopifyFormatCurrency(priceInfo.finalPrice, currencyFormat, currencyOptions)}
      </span>`;
        } else {
            if (showOriginalPrice && showCompareAtPrice && compareAtPrice && compareAtPrice > originalPrice) {
              //  html += `<span class="dollarlabs_pricelist--original_price" style="color: red; text-decoration: line-through; margin-right: 5px;font-size: 14px;">
         // ${shopifyFormatCurrency(compareAtPrice, currencyFormat, currencyOptions)}
        //</span>`;
                html += `<span class="dollarlabs_pricelist--final_price" style="color: red; font-size: 20px;">
          ${shopifyFormatCurrency(originalPrice, currencyFormat, currencyOptions)}
        </span>`;
            } else {
                html += `<span class="dollarlabs_pricelist--regular_price" style="color: black; font-size: 14px;">
          ${shopifyFormatCurrency(originalPrice, currencyFormat, currencyOptions)}
        </span>`;
            }
        }
        el.innerHTML = html;
        el.dataset.dollarlabsRendered = 'true';
        delete el.dataset.dollarlabsFallback;
    }

    function processNode(node) {
        if (!node) return;
        if (node.nodeType === Node.ELEMENT_NODE) {
            if (node.matches && node.matches('[data-custom-price-js]')) {
                renderPrice(node);
            }
            node.querySelectorAll && node.querySelectorAll('[data-custom-price-js]').forEach(renderPrice);
        }
    }

    function processAllPrices() {
        document.querySelectorAll('[data-custom-price-js]').forEach(el => {
            if (el.dataset.dollarlabsRendered === 'true') return;
            processNode(el);
        });
    }

    function whenCalculatorReady(timeout = 5000) {
        return new Promise((resolve) => {
            if (window.DollarlabsPriceCalculator && window.DollarlabsPriceCalculator.isInitialized) return resolve(true);
            const interval = setInterval(() => {
                if (window.DollarlabsPriceCalculator && window.DollarlabsPriceCalculator.isInitialized) {
                    clearInterval(interval); resolve(true);
                }
            }, 100);
            setTimeout(() => { clearInterval(interval); resolve(false); }, timeout);
        });
    }

    // initial run
    processAllPrices();

    // If calculator appears later, re-run only fallback elements
    whenCalculatorReady(5000).then((ready) => {
        if (ready) {
            document.querySelectorAll('[data-custom-price-js][data-dollarlabs-fallback="true"]').forEach(renderPrice);
        }
    });

    // MutationObserver for injected HTML (recommendations / AJAX)
    const observer = new MutationObserver(mutations => {
        mutations.forEach(m => {
            m.addedNodes && m.addedNodes.forEach(node => {
                processNode(node);
            });
        });
    });
    observer.observe(document.body, { childList: true, subtree: true });

    // Shopify section event fallback
    document.addEventListener && document.addEventListener('shopify:section:load', (evt) => {
        processNode(evt.target);
    });

    // small API
    window.DollarlabsPricing = {
        reprocess: processAllPrices,
        renderOne: renderPrice
    };

    console.log('[DollarlabsPricing] ready');
})();
